module.exports = __webpack_public_path__ + "img/h7.42abceff.jpg";